module.exports = __webpack_public_path__ + "media/mercs3.8a8247b8.mp4";